import React from 'react'

import Arrow from '../assets/images/arrow.png'


const VideoBanner = ({ backgroundImage, logo, video }) => {

  const [timing, setTiming] = React.useState(0)

  React.useEffect(() => {
    let interval = setInterval(() => {
      setTiming(timing => timing + 1)
      if (timing === 6) {
        clearInterval(interval)
        document.querySelector('.home-banner').classList.add('home-banner--loaded')
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <>
      <section className='home-banner home-banner--video' data-color={'#FFFFFF'}>
        <video poster={backgroundImage.localFile?.publicURL} autoPlay playsInline muted loop disableRemotePlayback>
          <source src={video} type='video/mp4' />
        </video>
        <div className={`logo ${timing > 0 ? 'fade-in' : ''}`} role='button' onClick={() => window && window.scroll({ top: window.innerHeight - 149, left: 0, behavior: 'smooth' })}>
          {logo && <img src={logo.localFile?.publicURL} alt='Whitefox' />}
        </div>
        <div className={`transacted ${timing > 2 ? 'fade-in' : ''}`}>
          <button type='button' className='arrow__scroll' onClick={() => window && window.scroll({ top: window.innerHeight - 149, left: 0, behavior: 'smooth' })}>
            <img className="arrow" src={Arrow} alt="Scroll Down" />
          </button>
        </div>
      </section>
      <div className='home-banner__padding' />
    </>
  )
}


export default VideoBanner
